import React, { Component } from "react";
import { connect } from "react-redux";
import { checkActivate, activeArchived } from "PollAction";
import { showError, showSuccess } from "ReduxErrorBar";
import ShowResult from "./show-result";
import ResultAnalytics from "./poll-result-analytics";
import LocaleStrings from "Languages";

class PollListItem extends Component {
  constructor(props) {
    super(props);
  }

  changeStatus = () => {
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }
    // this.props.activeArchived();
    if (this.props.poll && this.props.poll.isarchived) {
      // this.props.checkActivate(this.props.session, this.props.selectedSession, (response) => {
      //     if(response.success) {
      //         if(response.data.meta.count < 4) {
      this.props.activeArchived(
        this.props.session,
        this.props.poll.pollid,
        this.props.select,
        0,
        (res) => {
          if (res.success) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_message_poll_activated_success
            );
            this.props.pagination(pageNo);
          } else {
            this.props.showError(
              LocaleStrings.polls_qa_message_poll_activated_error
            );
          }
        }
      );
      //         }
      //         else {
      //             this.props.showError('Only 4 polls can active at a time.');
      //         }
      //     }
      //     else {
      //         this.props.showError('Something went wrong.');
      //     }
      // });
    } else {
      this.props.activeArchived(
        this.props.session,
        this.props.poll.pollid,
        this.props.select,
        1,
        (res) => {
          if (res.success) {
            this.props.showSuccess(
              LocaleStrings.polls_qa_message_poll_archived_success
            );
            this.props.pagination(pageNo);
          } else {
            this.props.showError(
              LocaleStrings.polls_qa_message_poll_archived_error
            );
          }
        }
      );
    }
  };

  render() {
    let { poll, dragData } = this.props;

    let checked = true;
    if (poll.isarchived) {
      checked = false;
    }

    return (
      <div
        className="row"
        style={{
          fontWeight: "normal",
          color: "rgb(63,68,88)",
          borderTop: "1px solid #e6edf3",
          padding: "10px 0",
          // cursor: "move",
        }}
      >
        <div className="col-sm-6 col-lg-8 d-flex align-items-baseline">
          <div>{dragData}</div>

          <div className="poll-questions">{this.props.poll.question}</div>
        </div>
        <div className="col-sm-2 col-lg-1">
          <span className="poll-result-action">
            <ResultAnalytics pollResult={poll} />
          </span>
        </div>
        <div className="col-sm-2 col-lg-1">
          <span className="poll-result-action">
            <ShowResult pollResult={poll} />
          </span>
        </div>
        <div className="col-sm-2 col-lg-1" style={{ paddingRight: 5 }}>
          {/* <div className="vcenter">{this.props.poll.option1}</div> */}

          {/* <span className="poll-result-action" >
                        <ShowResult pollResult={this.props.poll}/>
                    </span> */}

          <label className="poll-switch pull-right" style={{ margin: 0 }}>
            <input
              type="checkbox"
              onChange={this.changeStatus}
              checked={checked}
            />
            <span className="poll-slider poll-round"></span>
          </label>
        </div>
      </div>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    selectedSession: state.selectedSession.resource,
  };
};
export default connect(mapStateToProps, {
  checkActivate,
  activeArchived,
  showError,
  showSuccess,
})(PollListItem);
